import { Container } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import house from "../../asset/home.svg";
import send from "../../asset/send.svg";
import "../../styles/logo.css";
import { Header } from "../header";
import { useLoginStore } from "../helpers/state";
import { usePektaStore } from "../helpers/state";
import PektaHeader from "../helpers/pektaHeader";

toast.configure();

export function PektaForm5() {
  const { login } = useLoginStore();
  let navigate = useNavigate();

  function logout() {
    localStorage.clear();
    navigate("/login");
  }

  useEffect(() => {
    if (login.pektaAppStatus !== "none") {
      toast.warning(`Anda telah membuat permohonan`, {
        position: toast.POSITION.TOP_CENTER,
      });
      navigate("/myprofile");
    }
  });

  return (
    <div>
      <Header />

      <PektaHeader page={"4"} />

      <div className="bg-gray-50 w-full min-h-screen flex justify-center items-center p-4">
        <div className="max-w-2xl w-full bg-white rounded-lg p-8">
          <div className="text-center mb-8">
            <div className="w-20 h-20 mx-auto bg-lime-50 rounded-full flex justify-center items-center">
              <div className="w-16 h-16 bg-lime-100 rounded-full flex justify-center items-center">
                <img className="w-10 h-10" src={send} alt="Send Icon" />
              </div>
            </div>
            <p className="font-bold py-2 text-xl">
              Permohonan anda telah dihantar
            </p>
            <p className="text-gray-500">
              Sila semak emel anda untuk status permohonan
            </p>
            <p className="text-gray-500">yang lebih lanjut.</p>
          </div>
          <div className="text-center">
            <button
              className="border-2 bg-green-600 text-white rounded-lg w-full py-3 mt-4 flex items-center justify-center"
              onClick={() => {
                navigate("/myprofile");
              }}
            >
              <img className="w-5 h-6 mr-3" src={house} alt="House Icon" />
              Kembali ke profil
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
